// WHY IS THIS FILE JS AND NOT TS?
// The function below acesses methods and variables from the OneTrust window object
// and since OneTrust does not publish types, transitioning this file to typescript
// would require manually adding a bunch of potentially incorrect types

// Some analytics cookies contain ID in their name:
// _gclxxxx, _dc_gtm_UA-xxxxxxxx, _gat_xxxxxxxxxxxxxxxxxxxxxxxxxx.
// We would need a separate logic to delete them.
const ANALYTICS_COOKIE_PREFIXES = ['_gcl', '_dc_gtm_UA-', '_gat_', '_ga_']

/**
 * This is one of OneTrust.OnConsentChanged callbacks.
 * In case a user revoke consent for functional/analytics/targeting cookies,
 * we need to delete all previously set cookies from these categories to be GDPR-compliant.
 */
const deleteCookies = () => {
  // check if some cookies need to be deleted after user opt out
  const previousActiveGroups = window.previousOnetrustActiveGroups
    .split(',')
    .filter(Boolean)
  const activeGroups = window.OnetrustActiveGroups.split(',').filter(Boolean)
  const optOutGroups = previousActiveGroups.filter(
    groupId => activeGroups.indexOf(groupId) === -1
  )
  // for cross subdomain cookies we would need to delete cookies for
  // .n26.com in live, .staging-n26.com in staging, .dev-n26.com in dev
  const domainForCrossSubdomainCookies = window?.location?.hostname
    .split('.')
    .slice(-2)
    .join('.')

  if (optOutGroups.length) {
    const vendorList = window.Optanon.GetDomainData().GeneralVendors
    const cookieToDelete = vendorList
      // find all vendors for which cookies need to be deleted
      .filter(({ VendorCustomId }) => {
        return optOutGroups.indexOf(VendorCustomId) !== -1
      })
      // find all cookies to delete
      .reduce((acc, { Cookies }) => acc.concat(Cookies), [])
      .map(({ Name }) => Name)

    // some analytics/targeting cookies are cross subdomain
    // let's consider both cases
    cookieToDelete.forEach(cookieName => {
      document.cookie =
        cookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
      document.cookie =
        cookieName +
        `=; Domain=.${domainForCrossSubdomainCookies}; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
    })
  }

  if (optOutGroups.includes('C0003')) {
    const cookiePairs = document.cookie.split(';').map(pair => pair.trim())
    cookiePairs.forEach(cookie => {
      const [cookieName] = cookie.split('=')
      const hasPrefix = ANALYTICS_COOKIE_PREFIXES.some(prefix =>
        cookieName.startsWith(prefix)
      )

      if (hasPrefix) {
        document.cookie =
          cookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
        document.cookie =
          cookieName +
          `=; Domain=.${domainForCrossSubdomainCookies}; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
      }
    })
  }

  if (
    window.datadogRum?.isDataDogRUMScriptEnabled &&
    optOutGroups.includes('V89')
  ) {
    // If the cookie consent for DataDog was withdrawn, reload the page.
    // Right now there is no other way to stop gathering information after consent was withdrawn.
    // However, its on their radar and there are a lot of users asking for it
    // https://github.com/DataDog/browser-sdk/issues/1008
    location.reload()
  }

  window.previousOnetrustActiveGroups = window.OnetrustActiveGroups
}

export { deleteCookies }
